module.exports = __webpack_public_path__ + "static/img/12.d881b1b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/zh/12.png
// module id = ilQz
// module chunks = 0